export default __webpack_public_path__ + "static/duckdb-50c34686b050b48bdd7a112f85c265c2.png";